<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="'pages.sendBalkSms.title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
    [showRefreshBtn]="showRefreshBtn"
  >
    <div class="card-toolbar" after-btns>
      @if (!formPageConfig?.isEditMode) {
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'sendQueue'
            : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        iconSize="mdi-22px"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
      ></page-header-btn>
      }
      <ng-container *ngIf="formPageConfig?.isEditMode">
        <!-- back btn -->
        <a
          class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
          mat-ripple
          [matTooltip]="'common.back' | translate"
          (click)="onClose()"
        >
          <i class="mdi mdi-arrow-left mdi-20px p-0"></i>
        </a>
      </ng-container>
    </div>
  </app-page-header>

  <div class="app-page-content">
    <!-- #region app page Content-->
    <mat-stepper #stepper [linear]="true">
      <!-- #region step sending balk queries -->
      <!-- -->
      <mat-step #stepBalkQueries [completed]="totalSmsSendCount > 0">
        <ng-template matStepLabel>{{
          fields + "selectBalkQueries" | translate
        }}</ng-template>
        <!-- #region select balk queries -->
        <form [formGroup]="queryForm" autocomplete="off">
          <div class="row panels-row">
            <!-- #region Help Area-->
            <section class="tw-w-full tw-mt-[24px]">
              <div
                role="alert"
                class="alert tw-bg-gray-100 dark:tw-bg-dark-200 tw-border tw-border-dark-100 help-area tw-mb-0"
              >
                <h2
                  class="tw-mb-5 tw-p-1 rounded text-dark tw-flex-center"
                >
                  <i class="mdi mdi-help-circle mdi-36px"></i>
                  {{ "common.userManual" | translate }}
                </h2>

                <div
                  class="*:tw-border-b *:tw-border-dashed *:dark:tw-border-dark-100 *:tw-border-gray-300"
                >
                  <p>
                    <i
                      class="mdi mdi-18px mdi-numeric-1-circle mdi-16px tw-ml-1"
                    ></i>
                    <span
                      [innerHTML]="
                        'pages.sendingSystem.sendBulkSms.chooseAreaAndSetFilters'
                          | translate
                      "
                    ></span>
                  </p>
                  <p>
                    <i
                      class="mdi mdi-18px mdi-numeric-2-circle mdi-16px tw-ml-1"
                    ></i>
                    <span
                      [innerHTML]="
                        'pages.sendingSystem.sendBulkSms.calculateNumbers'
                          | translate
                      "
                    ></span>
                  </p>
                  <p>
                    <i
                      class="mdi mdi-18px mdi-numeric-3-circle mdi-16px tw-ml-1"
                    ></i>
                    <span
                      [innerHTML]="
                        'pages.sendingSystem.sendBulkSms.chooseNumbersCount'
                          | translate
                      "
                    ></span>
                  </p>
                  <p>
                    <i
                      class="mdi mdi-18px mdi-numeric-4-circle mdi-16px tw-ml-1"
                    ></i>
                    <span
                      [innerHTML]="
                        'pages.sendingSystem.sendBulkSms.addAreaToList'
                          | translate
                      "
                    ></span>
                  </p>
                  <p>
                    <i
                      class="mdi mdi-18px mdi-numeric-5-circle mdi-16px tw-ml-1"
                    ></i>
                    <span
                      [innerHTML]="
                        'pages.sendingSystem.sendBulkSms.clickOnNext'
                          | translate
                      "
                    ></span>
                  </p>
                </div>
              </div>
            </section>
            <section class="sm:tw-w-1/2 xl:tw-w-1/3 tw-mt-2">
              <fieldset class="tw-h-full secondary-panel">
                <legend class="tw-flex-center">
                  <i class="mdi mdi-earth-box mdi-24px tw-ml-2"></i>
                  {{ fields + "sendingRegion" | translate }}
                </legend>

                <div class="row">
                  <!-- state -->
                  <div class="tw-w-full">
                    <zones-select-search
                      #selStates
                      class="tw-w-full"
                      label="common.state"
                      type="byZoneType"
                      [zoneType]="ZoneType.Province"
                      [control]="queryForm?.get('stateControl')"
                      [value]="stateId"
                      (valueChange)="selectedItemsChanged($event, 'stateId')"
                      (onError)="onClose()"
                    >
                    </zones-select-search>
                  </div>
                  <!--   -->
                  <!-- end state -->

                  <!-- city -->
                  <div class="tw-w-full">
                    <zones-select-search
                      #selCities
                      class="tw-w-full"
                      label="common.city"
                      [control]="queryForm?.get('cityControl')"
                      [id]="stateId"
                      [value]="cityId"
                      (valueChange)="
                        stateId != null
                          ? selectedItemsChanged($event, 'cityId')
                          : ''
                      "
                      (onError)="onClose()"
                    >
                    </zones-select-search>
                  </div>
                  <!-- end city -->

                  <!-- region -->
                  <div class="tw-w-full">
                    <regions-select-search
                      #selRegions
                      class="tw-w-full"
                      [control]="queryForm?.get('regionControl')"
                      label="{{ fields }}region"
                      [id]="cityId"
                      [value]="regionId == null ? null : regionId"
                      (valueChange)="
                        stateId != null
                          ? selectedItemsChanged($event, 'regionId')
                          : ''
                      "
                      (onError)="onClose()"
                    >
                    </regions-select-search>
                  </div>
                  <!-- end region -->

                  <!-- business group -->
                  <div class="tw-w-full">
                    <business-group-select-search
                      #selBusinessGroups
                      class="tw-w-full"
                      label="{{ fields }}businessGroup"
                      [control]="queryForm?.get('businessGroupControl')"
                      [id]="null"
                      [value]="businessGroupId"
                      (valueChange)="
                        selectedItemsChanged($event, 'businessGroupId')
                      "
                    >
                    </business-group-select-search>
                  </div>
                  <!-- end business group -->

                  <!-- business sub group -->
                  <div class="tw-w-full">
                    <business-group-select-search
                      class="tw-w-full"
                      label="{{ fields }}businessSubGroup"
                      [control]="queryForm?.get('businessSubGroupControl')"
                      [fieldName]="'subGuild'"
                      [id]="businessGroupId"
                      [value]="businessSubGroupId"
                      (valueChange)="
                        businessGroupId != null
                          ? selectedItemsChanged($event, 'businessSubGroupId')
                          : ''
                      "
                    >
                    </business-group-select-search>
                  </div>
                  <!-- end business sub group-->
                </div>
              </fieldset>
            </section>
            <section class="sm:tw-w-1/2 xl:tw-w-2/3 tw-mt-2">
              <fieldset class="tw-h-full secondary-panel">
                <legend class="tw-flex-center">
                  <i class="mdi mdi-account-group mdi-24px tw-ml-2"></i>
                  <span class="tw-mt-1">
                    {{ fields + "sendToRegionDetails" | translate }}
                  </span>
                </legend>
                <form [formGroup]="secondQueryForm" autocomplete="off">
                  <div class="row">
                    <div class="xl:tw-w-1/2">
                      <!-- mobile operator type to apply in query -->
                      <enum-select-search
                        #matOperatorType
                        enumName="SmsAggregator"
                        [label]="fields + 'operatorType'"
                        [removable]="false"
                        [(value)]="mobileNumberOperatorIdOnStep"
                        [control]="secondQueryForm?.get('operatorTypeControl')"
                        (valueChange)="onChangeSecondaryQueryFilter()"
                      >
                      </enum-select-search>
                      <!-- end of mobile operator type to apply in query -->
                    </div>
                    <div class="xl:tw-w-1/2">
                      <!-- mobile number type to apply in query -->

                      <enum-select-search
                        #matNumberType
                        enumName="SimType"
                        [label]="fields + 'mobileType'"
                        [control]="
                          secondQueryForm?.get('mobileNumberTypeControl')
                        "
                        [removable]="false"
                        [(value)]="mobileNumberTypeOnStep"
                        (valueChange)="onChangeSecondaryQueryFilter()"
                      >
                      </enum-select-search
                      ><!-- end of mobile number type to apply in query -->
                    </div>
                    <div class="xl:tw-w-1/2">
                      <!-- prefix to apply in query -->

                      <form-field
                        class="tw-w-full"
                        [label]="fields + 'mobilePrefixOnStep'"
                        [maxLength]="6"
                        [control]="secondQueryForm?.get('prefixControl')"
                        [isLtr]="true"
                        textAlign="left"
                        fontSize="15px"
                        [(value)]="mobileNumberStartWith"
                        (valueChange)="onChangeSecondaryQueryFilter()"
                      >
                        <b
                          suffix-content
                          class="tw-text-xl tw-text-gray-700 dark:tw-text-gray-400 tw-relative tw-top-0.5"
                          >98</b
                        >
                      </form-field>
                      <!-- end of prefix to apply in query -->
                    </div>
                    <div class="xl:tw-w-1/2">
                      <!-- postal code to apply in query -->

                      <form-field
                        class="tw-w-full"
                        [label]="fields + 'postalCode'"
                        [control]="secondQueryForm?.get('postalCodeControl')"
                        [(value)]="postalCode"
                        (valueChange)="onChangeSecondaryQueryFilter()"
                      >
                      </form-field>
                      <!-- end of postal code to apply in query -->
                    </div>
                    <div class="xl:tw-w-1/2">
                      <!-- mobile operator type to apply in query -->
                      <enum-select-search
                        [label]="fields + 'gender'"
                        enumName="GenderType"
                        [control]="secondQueryForm?.get('genderControl')"
                        [removable]="false"
                        [(value)]="gender"
                        (valueChange)="onChangeSecondaryQueryFilter()"
                      >
                      </enum-select-search>
                      <!-- end of mobile operator type to apply in query -->
                    </div>
                    <div class="xl:tw-w-1/2">
                      <!-- total mobile number in selected query -->
                      <form-field
                        class="tw-w-full"
                        [label]="fields + 'totalMobileNumber'"
                        [value]="totalMobileCount | numberSeparator"
                        [isReadOnly]="true"
                        (valueChange)="
                          totalMobileCount = $event;
                          onChangeSecondaryQueryFilter()
                        "
                      >
                      </form-field>
                      <!-- end total mobile number in selected query -->
                    </div>
                    <div class="xl:tw-w-1/2" *ngIf="!isRandomSend">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [value]="smsStartFromOnStep"
                        (valueChange)="
                          smsStartFromOnStep = $event; changeIndex()
                        "
                        [control]="secondQueryForm?.get('startFromControl')"
                        [label]="fields + 'startFromOnStep' | translate"
                        [isReadOnly]="totalMobileCount == 0"
                        [min]="1"
                      >
                      </form-field>
                    </div>
                    <!-- end of start sending record in selected query -->

                    <div class="xl:tw-w-1/2">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [value]="smsCountToSendOnStep"
                        (valueChange)="
                          smsCountToSendOnStep = $event; changeIndex()
                        "
                        [control]="secondQueryForm?.get('countToSendControl')"
                        [label]="fields + 'totalSmsSendOnStep' | translate"
                        [isReadOnly]="totalMobileCount == 0"
                        [min]="1"
                      >
                      </form-field>
                    </div>
                    <!-- end of count sending record in selected query -->
                    <!--wrong index error-->
                    <mat-error *ngIf="isWrongIndex">
                      <div class="error-text">
                        <span class="text-error-color">{{
                          "messages.wrongIndex" | translate
                        }}</span>
                      </div>
                    </mat-error>

                    <!-- random -->
                    <div class="checkbox-section tw-my-2">
                      <mat-slide-toggle
                        formControlName="isRandomSend"
                        [(ngModel)]="isRandomSend"
                      >
                        {{
                          "common.isRandomSend" | translate
                        }}</mat-slide-toggle
                      >
                    </div>

                    <!-- buttons -->
                    <div class="xl:tw-w-1/2 tw-mt-1">
                      <button
                        mat-ripple
                        type="button"
                        class="btn btn-success tw-my-1 button-shadow tw-w-full tw-h-full tw-flex-center font-weight-500 btn-hover-rise"
                        (click)="calculateStepTotalItemCount()"
                        [disabled]="!canCalculateStepTotalItemCount()"
                      >
                        <ng-container *ngIf="!calculateCountLoading">
                          <span class="tw-mx-1 span-text-color">
                            {{ fields + "calculateTotalCount" | translate }}
                          </span>
                          <i class="mdi mdi-calculator mdi-18px"></i>
                        </ng-container>
                        <!-- loading -->
                        <ng-container *ngIf="calculateCountLoading">
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </ng-container>
                      </button>
                    </div>
                    <div class="xl:tw-w-1/2 tw-mt-1">
                      <button
                        mat-ripple
                        type="button"
                        [disabled]="
                          !queryForm.valid ||
                          !secondQueryForm.valid ||
                          loading ||
                          !isStepTotalItemCountCalculated ||
                          isWrongIndex ||
                          calculateCountLoading
                        "
                        class="btn tw-my-1 button-shadow tw-w-full tw-h-full tw-flex-center font-weight-500 btn-hover-rise"
                        [themeColor]="'btn'"
                        (click)="createRegionQuery()"
                      >
                        <span class="tw-mx-1 span-text-color">{{
                          "common.add" | translate
                        }}</span>
                        <i
                          class="mdi mdi-plus-thick mdi-18px tw-text-white"
                        ></i>
                      </button>
                    </div>
                  </div>
                </form>
              </fieldset>
            </section>

            <!-- #endregion-->
          </div>
          <div class="row query-table" *ngIf="totalSmsSendCount > 0">
            <!-- here we render the queries that user select number's from-->
            <div
              class="md:tw-w-full !tw-p-0 tw-mb-2 dynamic-table tw-relative table-responsive"
            >
              <table
                class="table table-striped-even table-head-custom table-vertical-center overflow-hidden"
              >
                <thead class="tw-border-b dark:tw-border-dark-100">
                  <tr class="fw-bold fs-6 tw-text-gray-800">
                    <th></th>
                    <th>
                      {{ "common.receivers" | translate }}
                    </th>
                    <th>
                      {{ fields + "startFromOnStep" | translate }}
                    </th>
                    <th>
                      {{ fields + "totalSmsSendOnStep" | translate }}
                    </th>
                    <th>
                      {{ "common.isRandomSend" | translate }}
                    </th>
                    <th>
                      <!-- {{ 'common.detail' | translate}} -->
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of queries; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.Text }}</td>
                    <td>{{ item.smsStartFromOnStep | numberSeparator }}</td>
                    <td>{{ item.smsCountToSendOnStep | numberSeparator }}</td>
                    <td>
                      <span>
                        <i
                          class="mdi mdi-check-bold text-success mdi-18px"
                          *ngIf="item.smsStartFromOnStep == -1"
                        ></i>
                        <i
                          class="mdi mdi-close-thick text-danger mdi-18px"
                          *ngIf="item.smsStartFromOnStep != -1"
                        ></i>
                      </span>
                    </td>
                    <td>
                      <a
                        (click)="deleteItemFromQuery(item)"
                        class="btn btn-sm"
                        [matTooltip]="'common.delete' | translate"
                      >
                        <i
                          class="mdi mdi-trash-can-outline mdi-20px text-danger"
                        ></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="md:tw-w-3/4 tw-mt-2">
              <div
                class="total-number-to-send alert dark:tw-bg-dark-200 tw-bg-gray-100 tw-font-medium tw-text-center"
              >
                {{ fields + "totalCountOfSendingSms" | translate }} :
                <span class="tw-font-black">
                  {{ totalSmsSendCount | numberSeparator }}
                </span>
              </div>
            </div>
            <div class="sm:tw-w-1/2 md:tw-w-1/4 tw-mt-2">
              <button
                class="btn h-75 btn-hover-rise button-shadow tw-w-full tw-flex-center font-weight-500"
                [themeColor]="'btn'"
                type="button"
                (click)="moveToStep2()"
              >
                {{ fields + "acceptAndNext" | translate }}
                <i class="mdi mdi-arrow-left mdi-18px tw-mr-2"></i>
              </button>
            </div>
          </div>
        </form>
        <!-- #endregion -->
      </mat-step>
      <!-- #endregion -->
      <!-- #region sms-info -->
      <mat-step #stepSmsInfo>
        <ng-template matStepLabel>{{
          fields + "selectMessageSettings" | translate
        }}</ng-template>
        <!-- #region form content-->
        <form [formGroup]="form" autocomplete="off">
          <div class="row panels-row">
            <app-base-send-sms
              formId="sendBalkSmsForm"
              [childTagName]="tagName"
              [config]="baseSendSmsConfig"
              [form]="form"
              [loading]="loading"
              [editModel]="formPageConfig.editData"
              [campaignTitle]="model.title"
              (model)="getBaseSendSmsModel($event)"
              (onSubmit)="onSubmit()"
              (onClosePage)="onClose()"
              (privateNumber)="getPrivateNumber($event)"
              [saveToCampaign]="model.saveToCampaign"
              (onSaveToCampaign)="onSaveToCampaign($event)"
            >
            </app-base-send-sms>
          </div>
        </form>
        <!-- #endregion-->
      </mat-step>
      <!-- sms info -->
    </mat-stepper>
    <!-- #end region -->
  </div>

  <!-- calcLoading -->
  <app-special-loading *ngIf="calcLoading" special-loading type="calculate">
  </app-special-loading>

  <!-- sendLoading -->
  <app-special-loading *ngIf="sendLoading" special-loading type="sending">
  </app-special-loading>
</app-page-body>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="sendBulkSMS"
    (hidePage)="onHideHelpPage()"
    title="pages.sendBalkSms.title"
  >
  </app-help-page>
</ng-container>
